const DEFAULT_PORTAL_ID = "__assaia_ui_portal";
export {
  DEFAULT_PORTAL_ID
};
